/**
 * Created by Marek.Bogdanovic on 2017-09-23.
 */
/**
 * Validation method that test if the field is valid ISBN (International Standard Book Number).
 */
export var isbn = function (value) {
    var isbn = value.replace(/[^\dX]/gi, '');
    if (value.length !== 11 || isbn.length !== 11) {
        return false;
    }
    var firstWeight = [3, 7, 6, 1, 8, 9, 4, 5, 2];
    var secondWeight = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    var chars = isbn.split('');
    var sum = 0;
    var modulo;
    var check = 0;
    for (var i = 0; i < chars.length - 2; i++) {
        sum += firstWeight[i] * parseInt(chars[i]);
    }
    modulo = sum % 11;
    if (modulo === 0) {
        check = 0;
    }
    else {
        check = 11 - modulo;
    }
    if (check !== parseInt(chars[9])) {
        return false;
    }
    else {
        sum = 0;
        check = 0;
        for (var i = 0; i < chars.length - 1; i++) {
            sum += secondWeight[i] * parseInt(chars[i]);
        }
        modulo = sum % 11;
        if (modulo === 0) {
            check = 0;
        }
        else {
            check = 11 - modulo;
        }
        if (check !== parseInt(chars[10])) {
            return false;
        }
        else {
            return true;
        }
    }
};
